<template>
    <div>
        <translation-string :translation="$t('jurisdictionRequirements.ukSelfCategorisation.restrictedInvestorTitlePage',)"
            class="title"
        />

        <translation-string
            v-for="(text, index) in investorTexts"
            :key="index"
            :translation="$t(text)"
            class="message"
        />

        <div class="options">
            <div v-for="(option,index) in restrictedHasInvestedLessThanTenPercentOptions"
                :key="index"
                class="radio__wrapper"
                @click="toggleRestrictedHasInvestedLessThanTenPercentOption(index)"
            >
                <div class="radio">
                    <div
                        class="radio__circle"
                    />
                    <div v-if="option.checked"
                        class="radio__circle--fill"
                    />
                </div>
                <label class="radio__label"
                    :for="index"
                >
                    <translation-string
                        class="uk-investor-statement__message"
                        :translation="option.text"
                    />
                </label>
            </div>
        </div>

        <translation-string :translation="$t('jurisdictionRequirements.ukSelfCategorisation.restristedInvestorText7')"
            class="message"
        />

        <custom-input ref="restrictedHasInvestedPercentInput"
            v-model.trim="restrictedHasInvestedPercent"
            :disabled="!restrictedHasInvestedLessThanTenPercent"
            :label="$t('jurisdictionRequirements.ukSelfCategorisation.percentage')"
            :placeholder="$t('jurisdictionRequirements.ukSelfCategorisation.percentageNetInvestedPlaceholder')"
            :name="$t('jurisdictionRequirements.ukSelfCategorisation.percentage')"
            :validateOnMount="false"
            required
            :validations="percentageValidations"
            :isValid.sync="isRestrictedHasInvestedPercentValid"
            @input="validateSteps"
        />

        <translation-string class="message"
            :translation="$t('jurisdictionRequirements.ukSelfCategorisation.and')"
        />
        <translation-string class="message"
            :translation="$t('jurisdictionRequirements.ukSelfCategorisation.restristedInvestorText8')"
        />

        <div class="options">
            <div v-for="(option,index) in restrictedWillInvestLessThanTenPercentOptions"
                :key="index"
                class="radio__wrapper"
                @click="toggleRestrictedWillInvestLessThanTenPercentOption(index)"
            >
                <div class="radio">
                    <div
                        class="radio__circle"
                    />
                    <div v-if="option.checked"
                        class="radio__circle--fill"
                    />
                </div>
                <label class="radio__label"
                    :for="index"
                >
                    <translation-string
                        class="uk-investor-statement__message"
                        :translation="option.text"
                    />
                </label>
            </div>
        </div>

        <translation-string class="message"
            :translation="$t('jurisdictionRequirements.ukSelfCategorisation.restristedInvestorText9')"
        />

        <custom-input ref="restrictedWillInvestPercentInput"
            v-model.trim="restrictedWillInvestPercent"
            :disabled="!restrictedWillInvestLessThanTenPercent"
            :label="$t('jurisdictionRequirements.ukSelfCategorisation.percentage')"
            :placeholder="$t('jurisdictionRequirements.ukSelfCategorisation.percentageNetIntendedToInvestPlaceholder')"
            :name="$t('jurisdictionRequirements.ukSelfCategorisation.percentage')"
            :validations="percentageValidations"
            required
            :isValid.sync="isRestrictedWillInvestPercentValid"
            @input="validateSteps"
        />

        <user-infos
            v-model="userInfo"
            :requirement="requirement"
            @updateFirstName="userInfo.firstName = $event"
            @updateLastName="userInfo.lastName = $event"
        />
    </div>
</template>

<style scoped lang="scss">
.title {
    font-size: 2.5rem;
    color: #002e3c;
    padding: 0 2rem;
    text-align: center;
    display: block;
    font-weight: bold;
    margin-bottom: 30px;
}

.message {
    display: block;
    font-size: 1.65rem;
    line-height: 28px;
    margin: 10px 0;
}

.options {
    & .radio {
        position: relative;

        &__wrapper {
            display: flex;
            margin: 20px 0;
            cursor: pointer;
        }

        &__circle {
            height: 15px;
            width: 15px;
            margin-right: 10px;
            border: 1px solid $lima-color;
            border-radius: 50%;

            &--fill {
                height: 11px;
                width: 11px;
                background-color: $lima-color;
                border-radius: 50%;
                position: absolute;
                top: 3px;
                left: 3px;
            }
        }

        &__label {
            font-size: 1.65rem;
            margin-top: -2px;
            cursor: pointer;
        }
    }
}
</style>

<script>
// Components
import customInput from '@webapp/components/form/custom-input.vue';
import userInfos from '@webapp/modules/customer-first/components/requirements/uk-self-categorisation-assessment/user-infos.vue';
import translationString from '@webapp/components/translation-string.vue';

// Validations
import {
    ukPercentageFormat, validNumber,
} from '@shared/validations/customer-first';

export default {
    name: 'restricted-investor-form',
    components: {
        customInput,
        userInfos,
        translationString,
    },
    props: {
        requirement: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            investorTexts: [
                'jurisdictionRequirements.ukSelfCategorisation.restristedInvestorText1',
                'jurisdictionRequirements.ukSelfCategorisation.restristedInvestorText2',
                'jurisdictionRequirements.ukSelfCategorisation.restristedInvestorText3',
                'jurisdictionRequirements.ukSelfCategorisation.restristedInvestorText4',
                'jurisdictionRequirements.ukSelfCategorisation.restristedInvestorText5',
                'jurisdictionRequirements.ukSelfCategorisation.restristedInvestorText6',
            ],
            restrictedHasInvestedLessThanTenPercent: null,
            restrictedHasInvestedPercent: null,
            isRestrictedHasInvestedPercentValid: false,
            restrictedWillInvestLessThanTenPercent: null,
            restrictedWillInvestPercent: null,
            isRestrictedWillInvestPercentValid: false,
            userInfo: {
                firstName: '',
                lastName: '',
            },
            restrictedHasInvestedLessThanTenPercentOptions: [
                {
                    checked: false,
                    text: this.$t('jurisdictionRequirements.ukSelfCategorisation.restrictedHasInvestedLessThanTenPercentOptionsYes'),
                    value: true,
                },
                {
                    checked: false,
                    text: this.$t('jurisdictionRequirements.ukSelfCategorisation.restrictedHasInvestedLessThanTenPercentOptionsNo'),
                    value: false,
                },
            ],
            restrictedWillInvestLessThanTenPercentOptions: [
                {
                    checked: false,
                    text: this.$t('jurisdictionRequirements.ukSelfCategorisation.restrictedWillIntendToInvestLessThanTenPercentOptionsYes'),
                    value: true,
                },
                {
                    checked: false,
                    text: this.$t('jurisdictionRequirements.ukSelfCategorisation.restrictedWillIntendToInvestLessThanTenPercentOptionsNo'),
                    value: false,
                },
            ],
        };
    },
    computed: {
        selectedRestrictedHasInvestedLessThanTenPercentOption() {
            return this.restrictedHasInvestedLessThanTenPercentOptions.find((option) => option.checked);
        },
        selectedRestrictedWillInvestLessThanTenPercentOption() {
            return this.restrictedWillInvestLessThanTenPercentOptions.find((option) => option.checked);
        },
        percentageValidations() {
            return [validNumber, ukPercentageFormat];
        },
        isFormValid() {
            const isRestrictedValid =
                this.restrictedHasInvestedLessThanTenPercent === false ||
                (this.restrictedHasInvestedLessThanTenPercent === true && this.isRestrictedHasInvestedPercentValid !== false);

            const isWillInvestValid =
                this.restrictedWillInvestLessThanTenPercent === false ||
                (this.restrictedWillInvestLessThanTenPercent === true && this.isRestrictedWillInvestPercentValid !== false);

            return (
                this.userInfo.firstName !== '' &&
                this.userInfo.lastName !== '' &&
                isRestrictedValid &&
                isWillInvestValid
            );
        },
    },
    methods: {
        updateRestrictedHasInvestedLessThanTenPercentOptionByIndex(index) {
            this.restrictedHasInvestedPercent = null;
            this.isRestrictedHasInvestedPercentValid = false;

            this.restrictedHasInvestedLessThanTenPercentOptions.forEach((opt) => {
                opt.checked = false;
            });

            this.$refs.restrictedHasInvestedPercentInput.reset();

            this.restrictedHasInvestedLessThanTenPercentOptions[index].checked = true;
            this.restrictedHasInvestedLessThanTenPercent = this.selectedRestrictedHasInvestedLessThanTenPercentOption.value;

            this.validateSteps();
        },

        toggleRestrictedHasInvestedLessThanTenPercentOption(index) {
            this.updateRestrictedHasInvestedLessThanTenPercentOptionByIndex(index);
        },

        updateRestrictedWillInvestLessThanTenPercentOptionByIndex(index) {
            this.restrictedWillInvestPercent = null;
            this.isRestrictedWillInvestPercentValid = false;

            this.restrictedWillInvestLessThanTenPercentOptions.forEach((opt) => {
                opt.checked = false;
            });

            this.$refs.restrictedWillInvestPercentInput.reset();

            this.restrictedWillInvestLessThanTenPercentOptions[index].checked = true;
            this.restrictedWillInvestLessThanTenPercent = this.selectedRestrictedWillInvestLessThanTenPercentOption.value;

            this.validateSteps();
        },

        toggleRestrictedWillInvestLessThanTenPercentOption(index) {
            this.updateRestrictedWillInvestLessThanTenPercentOptionByIndex(index);
        },

        onUserInfoUpdate(field, value) {
            this.userInfo[field] = value;
            this.validateSteps();
        },
        async validateSteps() {
            /* eslint-disable no-console */
            console.log('data', this.$data);
            await this.$nextTick();

            if (this.isFormValid) {
                this.$emit('completed', {
                    firstName: this.userInfo.firstName,
                    lastName: this.userInfo.lastName,
                    category: 'restricted',
                    restrictedHasInvestedLessThanTenPercent: this.restrictedHasInvestedLessThanTenPercent,
                    restrictedHasInvestedPercent: parseInt(this.restrictedHasInvestedPercent),
                    restrictedWillInvestLessThanTenPercent: this.restrictedWillInvestLessThanTenPercent,
                    restrictedWillInvestPercent: parseInt(this.restrictedWillInvestPercent),
                });
            } else {
                this.$emit('in-progress');
            }
        },
    },
};
</script>